import React, { useRef, useState, useEffect, forwardRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { API_URL_All } from '../../api';
import axiosInstance from '../../axiosInstance';
import { toast } from "react-toastify";
import * as general from '../../libs/general';
import { StarRating, LockingTicket } from '../../components/tickets/Tickets';


const CategoryEditor = ({ data, handleSearch }) => {
  const [show, setShow] = useState(true);
  const [isLocked, setIsLocked] = useState(true);
  const [model, setModel] = useState({});
  const [activeTab, setActiveTab] = useState('tab1');

  useEffect(() => {
    setActiveTab('tab1');
    fetchOneRecord(data.id);
  }, [data]);

  const handleActiveTab = async (tabName) => {
    setActiveTab(tabName);
    if (tabName == 'tab2') {
      //setTimeout(handleModalShow, 20);
    }
  }
  const handleProviderChange = async (name) => {
    console.log(name); 
  }
  const handleDeletCategory = (e) => {
    general.openConfirm(async () => {
      try {
        var requestApi = `/api/products/deleteCategory?id=${model.id}`;
        const response = await axiosInstance.get(requestApi);

        if (!response.data.success) {
          toast.error(response.data.message);
          return;
        }
        toast.success(response.data.message);
        if (handleSearch) handleSearch();
        handleModalClose();

      } catch (error) {
        console.error(error);
        toast.error(error.message);
      }
    })
  };

  const handleModalClose = (e) => {
    const allOldErrors = document.querySelectorAll('.error-msg');
    for (var i = allOldErrors.length - 1; i >= 0; i--) allOldErrors[i].remove();
    document.activeElement.blur();
    setShow(false);
  };

  const handleSubmitForm = async(e) => {
    e.preventDefault();
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;


    try {
      var requestApi = `/api/products/saveCategory`;
      const response = await axiosInstance.post(requestApi, model);
      if (!response.data.success) {
        general.showFormError('.show .modal-body', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message);
      if (handleSearch) handleSearch();
      handleModalClose();
    } catch (error) {
      toast.error(error.message);
    }

  };

  const handleModalShow = (e) => {
    var params = { providers: model.providers };
    window.initializeFilterValue(params);
  };

  const fetchOneRecord = async (id) => {
    setIsLocked(true);
    setModel({});
    try {
      var urlApi = `/api/products/getCategory?id=${id}`;
      const response = await axiosInstance.get(urlApi);

      var obj = response.data.data;
      var checkSize = obj.sizeX + obj.sizeY + obj.sizeZ;
      if (checkSize > 0) obj.size3 = true;

      if (id === 0 && data.productType === 'share') {
        obj.productType = 'share';
        obj.providers = data.providerName;
      }
      setModel(obj);
      setIsLocked(false);
      setShow(true);
    } catch (error) {
      console.error(error);
      setModel({error: error.message});
      toast.error(error.message);
    }
  };


  return (
    <Modal show={show} size="lg" onEntered={() => handleModalShow()}>
      <div className="modal-dialog11 modal-lg11">

        <form id="product_editor_form" className="form_validate normal-form" autoComplete="off" onSubmit={handleSubmitForm}>
          <div className="modal-content">
            <div className="modal-header position-relative flex-between">
              {model.id && (<span className="record_id">ID: {model.id}</span>)}
              <div>
                <h5 className="modal-title">{model.id ? 'Thông tin danh mục' : 'Danh mục mới'}</h5>
                {model.error && (
                  <div className="error-msg-server">{model.error}</div>
                )}
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={handleModalClose}
                aria-label="Đóng"
              ></button>
            </div>

            <div className="modal-body">


              <div data-name="tab1">

                <div className="row mt-3">
                  <div className="col-md-12 mb-3">
                    <div className="row">
                      <label className="col-form-label col-sm-2 col-4 form-label ">Cha</label>
                      <div className="col-sm-10 col-8 th filter-editor">
                        <span className="filter-ib" data-source-url={API_URL_All + '/api/products/searchTreeCategoryNames'}>
                          <input type="text" disabled={isLocked} placeholder="..." data-refer={model.id} value={model.parentName ?? ''} onChange={(e) => setModel({ ...model, parentName: e.target.value })} />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                  <div className="row">

                  <div className="col-md-12 form-item">
                    <div className="row">
                      <label className="col-form-label col-sm-2 col-4 form-label "><span className="required">Tên danh mục</span></label>
                      <div className="col-sm-10 col-8">
                        <input type="text" className="form-control" placeholder="Tên danh mục" data-required="Phải nhập mục này" disabled={isLocked} value={model.name ?? ''} onChange={(e) => setModel({ ...model, name: e.target.value })} />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 form-item">
                    <div className="row">
                      <label className="col-form-label col-sm-2 col-4 form-label "><span className="">Mô tả</span></label>
                      <div className="col-sm-10 col-8">
                        <textarea type="text" className="form-control" placeholder="..." disabled={isLocked} value={model.description ?? ''} onChange={(e) => setModel({ ...model, description: e.target.value })} > </textarea>
                      </div>
                    </div>
                  </div>
                </div>

                </div>


            </div>
            <div className="modal-footer justify-content-between">
              <div>
                {!isLocked && model.id && (
                  <button type="button" className="btn-small" onClick={() => handleDeletCategory()} >Xóa</button>
                )}
              </div>
              <button type="submit" className="btn-sm btn btn-primary">Lưu danh mục</button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default CategoryEditor;
